import {
  Action,
  ActionType,
  IStressCheckListResponse,
} from "models/stressCheck/stressCheckList";
import createReducer from "redux/createReducer";

export interface StressCheckListReducerType {
  loading: boolean;
  error?: string;
  stressCheckListResponse?: IStressCheckListResponse;
}

const defaultState: StressCheckListReducerType = {
  loading: false,
  error: undefined,
  stressCheckListResponse: undefined,
};

export const stressCheckListReducer = createReducer<StressCheckListReducerType>(
  defaultState,
  {
    [ActionType.STRESS_CHECK_LIST](state: StressCheckListReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.STRESS_CHECK_LIST_ERROR](
      state: StressCheckListReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
        stressCheckListResponse: undefined,
      };
    },

    [ActionType.STRESS_CHECK_LIST_SUCCESS](
      state: StressCheckListReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        stressCheckListResponse: action.payload,
      };
    },

    [ActionType.STRESS_CHECK_LIST_RESET_DATA](
      state: StressCheckListReducerType
    ) {
      return {
        ...state,
        loading: false,
        error: null,
      };
    },
  }
);
